class Util {
    // NEW: merge keeps target reference unlike extend where new object is returned (code is similar to extend.merge function but kept separate to avoid side effects)
    static merge(target, source, properties){
        // Merge the source object into the target object
        for (let prop in source) {
            if (source.hasOwnProperty(prop) && (properties == null || properties.indexOf(prop) !== -1)) {
                if (Object.prototype.toString.call(source[prop]) === '[object Object]') {
                    target[prop] = Util.merge(target[prop], source[prop]);
                } else if(source[prop] !== undefined) { // NEW: only extend if not undefined
                    target[prop] = source[prop];
                }
            }
        }

        return target;
    }

    static extend() {
        // variables
        let extended = {};

        // Merge the object into the extended object
        let merge = function(obj) {
            for (let prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                        extended[prop] = Util.extend(extended[prop], obj[prop]);
                    } else if(obj[prop] !== undefined) { // NEW: only extend if not undefined
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        // Loop through each object and conduct a merge
        for (let i = 0; i < arguments.length; i++) {
            let obj = arguments[i];
            merge(obj);
        }

        return extended;
    }

    static deepCopy(sourceObject, excludePatterns) {

        // no excluded > deep copy the whole object directly
        if (!excludePatterns || excludePatterns.length === 0) {
            return JSON.parse(JSON.stringify(sourceObject));
        }

        // Function to convert a pattern to RegExp if it's a string with wildcards
        const toRegExp = pattern => {
            return pattern instanceof RegExp ? pattern : new RegExp('^' + pattern.replace(/\*/g, '.*') + '$');
        };

        // Convert all patterns to regex
        const regexPatterns = excludePatterns.map(toRegExp);

        // Function to determine if a key matches any of the regex patterns
        const isExcluded = key => regexPatterns.some(regex => regex.test(key));

        // Filter out the excluded keys
        const filteredSource = Object.keys(sourceObject)
            .filter(key => !isExcluded(key))
            .reduce((acc, key) => {
                acc[key] = sourceObject[key];
                return acc;
            }, {});

        // Return the deeply copied filtered object
        return JSON.parse(JSON.stringify(filteredSource));
    }

    static isElement(element){
        if(typeof element  === 'object' && element.nodeType !== undefined){
            return true;
        } else{
            return false;
        }
    }

    static isNodeList(nodes) {
        let stringRepr = Object.prototype.toString.call(nodes);

        let isNodeList = typeof nodes === 'object' &&
            /^\[object (HTMLCollection|NodeList|RadioNodeList|Object)\]$/.test(stringRepr) &&
            (typeof nodes.length === 'number') &&
            (nodes.length === 0 || (typeof nodes[0] === "object" && nodes[0].nodeType > 0));

        // NEW: additional array check (old polyfills of document.querySelectorAll return native array instead of NodeList)
        if(!isNodeList && Array.isArray(nodes) && nodes.length > 0){
            return Util.isElement(nodes[0]);
        }

        return isNodeList;
    }

    static isInPage(node) {
        // source: https://developer.mozilla.org/en-US/docs/Web/API/Node/contains
        return (node === document.body) ? false : document.body.contains(node);
    }

    static isHidden(node){
        // check all indicator that this node is hidden                                                                                         // NEW: some elements have a 1px but use overflow:hidden ..
        return node.offsetHeight === 0 || node.offsetWidth === 0 || node.offsetParent === null || window.getComputedStyle(node).display === 'none' || (node.offsetHeight === 1 && node.offsetWidth === 1)
    }

    static isMinSize(node, minWidth = 1, minHeight = 1){
        // Check if the element's width and height a minimum size
        const rect = node.getBoundingClientRect();

        return !(rect.width > minWidth || rect.height > minWidth);
    }

    static isScrolledIntoView(node) {
        let rect = node.getBoundingClientRect();
        let elemTop = rect.top;
        let elemBottom = rect.bottom;

        // Only completely visible elements return true:
        let isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
        // Partially visible elements return true:
        //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return isVisible;
    }

    static matches(element, selector){
        // fallback matches Polyfill ( IE support )
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                (Element.prototype).matchesSelector ||
                (Element.prototype).mozMatchesSelector ||
                (Element.prototype).msMatchesSelector ||
                (Element.prototype).oMatchesSelector ||
                (Element.prototype).webkitMatchesSelector ||
                function (s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) { }
                    return i > -1;
                };
        }

        return element.matches(selector);
    }

    static matchesIncludeParent(element, selector){
        if(element){
            if(Util.matches(element, selector) || Util.findParent(element, selector) != null){
                return true;
            }
        }
        return false;
    }

    static findParent(element, selector){

        // newest browser function "element.closest"
        if ("function" == typeof element.closest) {
            return element.closest(selector) || null;
        }

        // fallback with "element.matches"
        for (; element;) {
            if (Util.matches(element,selector)) {
                return element;
            }
            element = element.parentElement;
        }
        return null;
    }

    static findInnerDimensions(node){  // source https://stackoverflow.com/a/56531945
        let computedStyle = getComputedStyle(node)

        let width = node.clientWidth // width with padding
        let height = node.clientHeight // height with padding

        height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom)
        width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)
        return { height, width };
    }

    static getCalculatedPosition(node) {
        const body = document.body;
        const documentElement = document.documentElement;

        const scrollTop = window.pageYOffset || documentElement.scrollTop || body.scrollTop;
        const scrollLeft = window.pageXOffset || documentElement.scrollLeft || body.scrollLeft;
        const elementRect = node.getBoundingClientRect();

        return {
            top: elementRect.top + scrollTop,
            left: elementRect.left + scrollLeft,
            right: elementRect.left + scrollLeft + elementRect.width,
            bottom: elementRect.top + scrollTop + elementRect.height,
        };
    }

    static findElementContainsText(selector, text, parent = document) {
        return Util.findElementContainsRegex(selector, new RegExp(text), parent);
    }

    static findElementContainsRegex(selector, regex, parent = document) {
        let elements = parent.querySelectorAll(selector);
        return Array.prototype.filter.call(elements, function(element){
            return regex.test(element.textContent);
        });
    }

    static escapeRegex(string){
        // escapes reserved regex characters to make them explicit - required when search e.g  "First (name)" =  "First \(name\)"
        return string.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

    static readCookie(name) {
        name += '=';
        for (let ca = document.cookie.split(/;\s*/), i = ca.length - 1; i >= 0; i--){
            if (!ca[i].indexOf(name)){
                return ca[i].replace(name, '');
            }
        }
    }

    static writeCookie(name, value, exDays, path = '/') {
        let exDate = new Date();
        // add days to current date
        exDate.setDate(exDate.getDate() + exDays);
        let expires = ((exDays == null) ? '' : '; expires=' + exDate.toUTCString());
        document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + (path ? '; path=' + path : '') + ';'
    }

    static removeCookie(name, path = '/') {
        document.cookie = name + '=; Path=' + path + '; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    static addStyleElement(css, container){

        // default add to head
        if(!container || container == 'head'){
            container = document.head || document.getElementsByTagName('head')[0];
        }

        let style = document.createElement('style');

        style.appendChild(document.createTextNode(css));

        container.appendChild(style);

        return style;
    }

    static addScriptElement(js, container){

        // INFO: alternative would be to just execute:  Function(js)();

        // default add to head
        if(!container || container == 'head'){
            container = document.head || document.getElementsByTagName('head')[0];
        }

        let script = document.createElement('script');

        script.appendChild(document.createTextNode(js));

        container.appendChild(script);

        return script;
    }

    static objectKeys(obj){
       if (!Object.keys) {
            let keys = [], k;
            for (k in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, k)) {
                    keys.push(k);
                }
            }
            return keys;
        }
        return Object.keys(obj);
    }

    static hasQueryParam(url, param) {
        return url.indexOf(param) !== -1;
    }

    static getQueryParam(url, param) {
        //this expression is to get the query strings
        let reg = new RegExp( '[?&]' + param + '=([^&#]*)', 'i' );
        let queryString = reg.exec(url);
        return queryString ? decodeURIComponent(queryString[1]) : null;
    }

    static getQueryParams(url) {
        let queryParams = {};
        //create an anchor tag to use the property called search
        let anchor = document.createElement('a');
        //assigning url to href of anchor tag
        anchor.href = url;
        //search property returns the query string of url
        let queryStrings = anchor.search.substring(1);
        let params = queryStrings.split('&');

        for (let i = 0; i < params.length; i++) {
            let pair = params[i].split('=');
            queryParams[pair[0]] = decodeURIComponent(pair[1]);
        }
        return queryParams;
    }

    static buildQueryParams(params){
        return Object.keys(params).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        }).join('&');
    }

    static debounced(delay, fn) {
        let timerId;
        return function (...args) {
            if (timerId) {
                clearTimeout(timerId);
            }
            timerId = setTimeout(() => {
                fn(...args);
                timerId = null;
            }, delay);
        };
    }

    static throttled(delay, fn) {
        let lastCall = 0;
        return function (...args) {
            const now = (new Date()).getTime();
            if (now - lastCall < delay) {
                return;
            }
            lastCall = now;
            return fn(...args);
        };
    }

    static decodeHtml(encodedHtml){
        // source: https://gomakethings.com/decoding-html-entities-with-vanilla-javascript/
        const txt = document.createElement('textarea');
        txt.innerHTML = encodedHtml;
        return txt.value;
    }

    static pathBaseName(src, extension = true) {
        let baseName = src.split('/').pop();
        if(!extension){
            baseName = baseName.substring(0, baseName.lastIndexOf('.'))
        }
        // cut file extension
        return baseName;
    }

    static getAgent(){
        return navigator.userAgent || navigator.vendor || window.opera;
    }

    static isInApp(ua) {
        //return true;
        return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1 ) || (ua.indexOf("Instagram") > -1);
    }

    static isFacebook(ua) {
        return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1 );
    }

    static isInstagram(ua) {
        return (ua.indexOf("Instagram") > -1);
    }

    static isIOS(ua) {
        ua = ua.toLowerCase();
        return (ua.indexOf("iphone") > -1) || (ua.indexOf("ipad") > -1);
    }

    static isAndroid(ua) {
        ua = ua.toLowerCase();
        return (ua.indexOf("android") > -1);
    }

    static isMobile(ua){
        return this.isAndroid(ua) || this.isIOS(ua);
    }

    static getImageSize(src){
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                resolve({width: img.width, height: img.height});
            };
            img.onerror = reject;
            img.src = src;
        });
    }

    static convertSizeToUnit(size, dpi, unit) {
        // convert pixels to inches
        let widthInInches = size.width / dpi;
        let heightInInches = size.height / dpi;

        // convert to the requested unit
        switch (unit) {
            case 'mm':
                return {
                    width: Number((widthInInches * CM_PER_INCH * 10).toFixed(2)),
                    height: Number((heightInInches * CM_PER_INCH * 10).toFixed(2))
                }
            case 'cm':
                return {
                    width: Number((widthInInches * CM_PER_INCH).toFixed(2)),
                    height: Number((heightInInches * CM_PER_INCH).toFixed(2))
                };
            case 'm':
                return {
                    width: Number((widthInInches * CM_PER_INCH / 100).toFixed(2)),
                    height: Number((heightInInches * CM_PER_INCH / 100).toFixed(2))
                };
            case 'inch':
                return {
                    width: Number(widthInInches.toFixed(2)),
                    height: Number(heightInInches.toFixed(2))
                };
            case 'feet':
                return {
                    width: Number((widthInInches / INCH_PER_FOOT).toFixed(2)),
                    height: Number((heightInInches / INCH_PER_FOOT).toFixed(2))
                };
        }

        return null;
    }

}

const CM_PER_INCH = 2.54;
const INCH_PER_FOOT = 12;

export default Util;
